"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmplitudeTracker = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _base = require("./base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var debug = (0, _debug.default)('rentspree-tracker:amplitude');

/**
 * The class for Amplitude tracker
 * @param {AmplitudeSDK} options.amplitudeSDK the amplitude SDK
 * @param {String} options.apiKey the api key of amplitude
 * @param {Object} options.amplitudeConfig the amplitude sdk config object [list of configuration options](https://developers.amplitude.com/?javascript#sdk-advanced-settings)
 * @extends BaseTracker
 */
var AmplitudeTracker = exports.AmplitudeTracker = /*#__PURE__*/function (_BaseTracker) {
  _inherits(AmplitudeTracker, _BaseTracker);
  function AmplitudeTracker(options) {
    var _this;
    _classCallCheck(this, AmplitudeTracker);
    _this = _callSuper(this, AmplitudeTracker, [options]);
    _this.amplitudeSDK = options.amplitudeSDK;
    _this.apiKey = options.apiKey;
    _this.amplitudeConfig = _objectSpread({
      includeUtm: true,
      includeReferrer: true
    }, options.amplitudeConfig);
    if (_this.amplitudeSDK && _this.apiKey) {
      debug('initialize Amplitude for Instance %o', options.amplitudeSDK);
      debug('initialize Amplitude Instance for API KEY %o', options.apiKey);
      debug('initialize Amplitude with Config %o', _this.amplitudeConfig);
      _this.getTracker().init(_this.apiKey, null, _this.amplitudeConfig);
    }
    return _this;
  }

  /**
   * Static method for getting the amplitude tracker
   * @returns {Function | Proxy} the amplitude instance if it exist,
   * this method will return Proxy to avoid error
   */
  _createClass(AmplitudeTracker, [{
    key: "getTracker",
    value: function getTracker() {
      if (this.amplitudeSDK) {
        debug('return amplitude instance');
        return this.amplitudeSDK.getInstance();
      }
      debug('return proxy object for now');
      return new Proxy({}, {
        get: function get() {
          return function () {};
        }
      });
    }

    /**
     * Identify the user by calling `setUserId(userId)`
     * the `userId` is a return from `options.mapUserIdentity(profile)`
     * the method also send user properties for identify user in amplitude by calling
     * `identify(userPropertiesObj)`
     * the `userPropertiesObject` is a return from function
     * `_setUserProperties(this.mapUserProfile(profile))`
     * which will create amplitude's user identify object from mapped user data
     * the `mapUserProfile` should return the data with format below
     * ```javascript
     * {
     *    id: {
     *      value: "this-is-user-id",
     *      setOnce: true
     *    }
     * }
     * ```
     *  which value is the value of the key
     *  setOnce is indicator to set this key as unchangeable value in amplitude
     * @param {Object} profile the profile object
     */
  }, {
    key: "identifyUser",
    value: function identifyUser(profile) {
      debug('identify user %o', profile);
      var mappedIdentity = this.mapUserIdentity(profile);
      var mappedProfile = this.mapUserProfile(profile);
      debug('mappedProfile %o', mappedProfile);
      // eslint-disable-next-line no-underscore-dangle
      var amplitudeUserIdentifierObj = this._setUserProperties(mappedProfile);
      debug('amplitude.setUserId(%s)', mappedIdentity);
      this.getTracker().setUserId(mappedIdentity);
      debug('amplitude.identify(%o)', amplitudeUserIdentifierObj);
      this.getTracker().identify(amplitudeUserIdentifierObj);
    }

    /**
     * This method is identifying for the amplitude analytics only
     * @param {Object} profile the user profile data
     */
  }, {
    key: "identifyAmplitude",
    value: function identifyAmplitude(profile) {
      debug('identify user for the amplitude only %O', profile);
      this.identifyUser(profile);
    }
  }, {
    key: "_setUserProperties",
    value: function _setUserProperties() {
      var mappedProfile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var identifyObj = new this.amplitudeSDK.Identify();
      var keys = Object.keys(mappedProfile);
      keys.forEach(function (key) {
        if (mappedProfile[key].setOnce) {
          identifyObj.setOnce(key, mappedProfile[key].value);
        } else {
          identifyObj.set(key, mappedProfile[key].value);
        }
      });
      return identifyObj;
    }

    /**
     * track the event by calling `logEvent("event name here", properties)`
     * @param {String} eventName the eventName
     * @param {Object} properties the properties to be passed to amplitude
     */
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      debug('amplitude track event for name:%s, properties:%o', eventName, properties);
      this.getTracker().logEvent(eventName, properties);
    }

    /**
     * generate new session for amplitude tracker when user logout
     * set userId to null
     */
  }, {
    key: "logout",
    value: function logout() {
      debug('set amplitude user to null');
      this.getTracker().setUserId(null);
    }
  }]);
  return AmplitudeTracker;
}(_base.BaseTracker);